// atN 用于产品页
// ifOpen 用于小菜单栏打开关闭 false表示关闭
// ifDrop 用于菜单栏的折叠 false表示收回
const state = {
    atN:'vr',
    ifOpen: false,
    // ifDrop: false,
}

const getters = {

}

const mutations = {
    change_atN(state,atN){
        state.atN = atN
    },

    change_ifOpen(state,ifOpen){
        state.ifOpen = ifOpen
    },

    // change_ifDrop(state,ifDrop){
    //     state.ifDrop = ifDrop
    // }
}

const actions = {

}

export default{
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}